(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    // Prevent menu drawer links from being intercepted by cart drawer handlers
  (function() {
    // Run immediately and also on DOMContentLoaded to catch dynamically added links
    function setupMenuDrawerLinkProtection() {
      const menuDrawerLinks = document.querySelectorAll('#menu-drawer a.menu-drawer__menu-item');
      menuDrawerLinks.forEach(function(menuLink) {
        // Skip if already protected
        if (menuLink.hasAttribute('data-menu-drawer-link-protected')) return;
        menuLink.setAttribute('data-menu-drawer-link-protected', 'true');
        
        // Add click handler in capture phase to run before cart drawer handler
        menuLink.addEventListener('click', function(e) {
          // Check if this is NOT the cart icon
          const cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon && menuLink !== cartIcon && !cartIcon.contains(menuLink)) {
            // This is a menu drawer link - ensure normal navigation
            // Stop propagation to prevent cart drawer from intercepting
            e.stopImmediatePropagation();
            // Don't prevent default - let the link navigate normally
            return true;
          }
        }, true); // Capture phase - runs before other handlers
      });
    }
    
    // Run immediately
    setupMenuDrawerLinkProtection();
    
    // Also run on DOMContentLoaded in case links are added dynamically
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupMenuDrawerLinkProtection);
    } else {
      // DOM already loaded, run after a short delay to ensure cart drawer is initialized
      setTimeout(setupMenuDrawerLinkProtection, 100);
    }
    
    // Also watch for new menu drawer links being added
    const menuDrawer = document.querySelector('#menu-drawer');
    if (menuDrawer) {
      const observer = new MutationObserver(function(mutations) {
        setupMenuDrawerLinkProtection();
      });
      observer.observe(menuDrawer, {
        childList: true,
        subtree: true
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
